import React, { useState } from 'react';

const ContactSection = () => {
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    try {
      await fetch('https://formsubmit.co/contacto@stepscolombia.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(data),
      });
      setFormStatus('Mensaje enviado con éxito. ¡Gracias por contactarnos!');
      e.target.reset();
    } catch (error) {
      setFormStatus('Hubo un error al enviar el mensaje. Inténtalo de nuevo.');
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#007dc6] mb-4">Contáctanos</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">Estamos listos para ayudarte a llevar tu negocio al siguiente nivel.</p>
        </div>
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 mb-12 lg:mb-0 lg:pr-12">
            <form className="space-y-6 bg-[#007dc6] p-8 rounded-xl" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="block text-white font-medium mb-2">Nombre</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                  placeholder="Tu nombre"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-white font-medium mb-2">Correo electrónico</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                  placeholder="tu@email.com"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-white font-medium mb-2">Mensaje</label>
                <textarea 
                  id="message" 
                  name="message"
                  rows="5" 
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                  placeholder="Cuéntanos sobre tu proyecto"
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="bg-white text-[#007dc6] px-8 py-3 rounded-full font-bold hover:bg-gray-200 transition-colors w-full"
              >
                Enviar mensaje
              </button>
              {formStatus && <p className="text-white text-sm mt-4">{formStatus}</p>}
            </form>
          </div>

          <div className="lg:w-1/2 lg:pl-12">
            <div className="bg-gray-50 p-8 rounded-xl h-full">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Información de contacto</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-[#00bff2] p-2 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-700">Teléfonos</h4>
                    <p className="text-gray-600">(+57) 601 6583956</p>
                    <p className="text-gray-600">+1 (787) 516-6710</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-[#00bff2] p-2 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-700">Correo electrónico</h4>
                    <p className="text-gray-600">contacto@stepscolombia.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-[#00bff2] p-2 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-700">Dirección</h4>
                    <p className="text-gray-600">Calle 118 #19-52 Edificio Acocentro Oficina 206 Bogotá</p>
                  </div>
                </div>

                {/* Botón WhatsApp dentro de la tarjeta de contacto */}
                <div className="pt-4">
                  <a
                    href="https://wa.me/17875166710?text=ESTUVE%20MIRANDO%20TU%20PAGINA%20WEB%20%22STEPSCOLOMBIA.COM%22%20ME%20INTERESAN%20TUS%20SERVICIOS"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-semibold transition-colors"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-white" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.52 3.48A11.84 11.84 0 0012 0C5.38 0 0 5.38 0 12c0 2.1.55 4.16 1.6 5.97L0 24l6.17-1.6A11.84 11.84 0 0012 24c6.62 0 12-5.38 12-12 0-3.19-1.25-6.19-3.48-8.52zM12 22c-1.88 0-3.7-.49-5.28-1.4l-.38-.22-3.67.95.97-3.58-.25-.38A9.86 9.86 0 012 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10z" />
                      <path d="M17.57 14.5c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14s-.7.88-.85 1.06c-.16.18-.31.2-.58.07s-1.13-.42-2.15-1.33c-.79-.7-1.32-1.56-1.48-1.82s-.02-.4.12-.53c.12-.12.27-.31.4-.46.13-.15.18-.25.27-.42.09-.18.05-.34-.02-.48s-.61-1.48-.84-2.03c-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.47.07-.72.34s-.95.93-.95 2.26.97 2.62 1.1 2.8c.13.18 1.91 2.93 4.63 4.11.65.28 1.16.44 1.56.56.66.21 1.26.18 1.74.11.53-.08 1.6-.65 1.83-1.27.23-.61.23-1.14.16-1.27-.07-.13-.25-.2-.52-.34z" />
                    </svg>
                    Enviar mensaje por WhatsApp
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* Google Maps Embed */}
        <div className="mt-12">
          <iframe
            title="Ubicación"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.692246472905!2d-74.0575036857357!3d4.702196843422612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9a2164906d11%3A0xf53ff37b4317c0e4!2sCalle%20118%20%2319-52%2C%20Bogot%C3%A1!5e0!3m2!1ses!2sco!4v1691683022643!5m2!1ses!2sco"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full rounded-xl"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
